// extracted by mini-css-extract-plugin
module.exports = {"container":"aoATs","separator":"dNbk6","spacing":"_324hh","submit":"IrJ61","spinner":"_17q7W"};